import {
  PORTAL_SUB_NAV_BAR_CLASS,
  PORTAL_SUB_NAV_ROW_CLASS,
} from "@/components/portal/portal-sub-nav-styles";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { Link } from "@tanstack/react-router";
import { ChevronLeft } from "lucide-react";
import type { ReactNode } from "react";

export {
  SETUP_ACTIVE_TAB_CLASS,
  SETUP_TAB_TRIGGER_CLASS,
  SETUP_TABS_LIST_CLASS,
} from "@/components/portal/portal-sub-nav-styles";

interface SetupPageTabBarProps {
  dashboardLink: string;
  children: ReactNode;
}

export function SetupPageTabBar({
  dashboardLink,
  children,
}: SetupPageTabBarProps) {
  return (
    <nav
      className={cn(PORTAL_SUB_NAV_BAR_CLASS, "shrink-0 -mx-4 md:-mx-6")}
      aria-label="Setup sections"
    >
      <div className={PORTAL_SUB_NAV_ROW_CLASS}>
        <Button
          variant="link"
          size="sm"
          asChild
          className="has-[>svg]:pl-0 shrink-0 text-muted-foreground hover:text-foreground"
        >
          <Link to={dashboardLink} className="flex items-center gap-1">
            <ChevronLeft className="h-4 w-4" />
            <span>Back to dashboard</span>
          </Link>
        </Button>
        {children}
      </div>
    </nav>
  );
}
